import * as React from 'react';
import 'fontsource-roboto';
import '../app.css';
import Button from '@material-ui/core/Button';
import {
  Box,
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Typography,
} from '@material-ui/core';

interface ManifestMismatchDialogProps {
  trackingNumber: string;
  showModal: boolean;
  onClose: (value?: string, managerCode?: string) => void;
}

const ManifestMismatchDialog: React.FC<ManifestMismatchDialogProps> = (
  { trackingNumber, showModal, onClose },
) => {
  const [details, setDetails] = React.useState<string>('');
  const [managerCode, setManagerCode] = React.useState<string>('');

  const handleCancel = () => {
    setDetails('');
    setManagerCode('');
    onClose();
  };
  const handleSave = () => {
    onClose(details, managerCode);
  };
  const handleDetailsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDetails(event.target.value);
  };
  const handleManagerCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setManagerCode(event.target.value);
  };

  return (
    <Dialog onClose={handleCancel} open={showModal}>
      <DialogTitle>
        <Typography variant="overline">
          {'CURRENT BOX · #'}
          {trackingNumber}
        </Typography>
        <Typography variant="h5" id="dialog-header">{'Manifest is short on repair items'}</Typography>
        <Typography variant="body2" color="textSecondary">
          {'Provide more information on shortage of repair items. Requires manager approval.'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <TextField size="small" id="manifest-mismatch-modal-details-input" fullWidth label="Details" variant="outlined" value={details} onChange={handleDetailsChange} />
        <Box p={1} />
        <TextField
          size="small"
          id="manifest-mismatch-modal-manager-code-input"
          fullWidth
          label="Manager Code"
          variant="outlined"
          type="password"
          value={managerCode}
          onChange={handleManagerCodeChange}
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" variant="text" onClick={handleCancel}>{'CANCEL'}</Button>
        <Button color="primary" variant="contained" disabled={!(managerCode && managerCode.length > 0)} onClick={handleSave}>{'SAVE UPDATES'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ManifestMismatchDialog;
